import React from 'react';
import Layout from '../components/Layout';
import Reveal, { SplitWords } from '../components/Reveal';

/**
 * @author Nelson
 */
const Support = () => (
    <Layout title="App Support" pad="plain">
        <header className="page__head">
            <h1 className="page__title page__title--display">
                <SplitWords text="App Support" start={120} />
            </h1>
        </header>

        <div className="prose">
            <Reveal as="p" delay={400}>
                If you need help or have questions regarding this app, feel free to contact us:
            </Reveal>
            <Reveal as="ul" delay={470}>
                <li>Support Email: <a className="u-link" href="mailto:customersupport@appancestor.com">customersupport@appancestor.com</a></li>
                <li>Business Name: YUAN Lab Enterprise</li>
                <li>Location: Bukit Mertajam, Penang, Malaysia</li>
            </Reveal>
            <Reveal as="p" delay={540}>
                Response time: 1–2 business days
            </Reveal>

            <Reveal className="section" delay={610}>
                <p style={{ color: 'var(--text-dim)', fontSize: 'var(--fs-sm)' }}>
                    This website and application are owned and operated by <strong>YUAN Lab Enterprise</strong><br />
                    Company Registration No: <strong>JM1023116-P</strong><br />
                    Registered in Malaysia.
                </p>
            </Reveal>
        </div>
    </Layout>
);

export default Support;
